export class PortalComponentConstants {
    static ALERT_API_CONTEXT = "icealert-nxi-services/";
  
    static AdaPageContentIgnoreList: string[] = [
        'midlogin',
        'registration',
        'registration-check-status',
        'account-new-userid-nao',
        'disclosure',
        'duplicatesessionconfirmation',
        'edelivery-pending-enroll',
        'paybills',
        'messagecenter',
        'account-profile',
        'managedaccounts',
        'rateboard',
        'watchlist'
    ];
    static AdaComponentIgnoreList: string[] = [
        'dojo-mid-login',
        'dojo-login-messages',
        'dojo-account-status',
        'dojo-portfolio-disclaimers',
        'dojo-download-links',
        'dojo-rtquote-toggle',
        'balances-disclaimers',
        'dojo-vot-chart',
        'dojo-ugl-disclaimers',
        'dojo-rgl-disclaimers',
        'com_pershing_netx_shared_pagesettings_large',
        'f2-common',
        'com_pershing_netx_shared_disclaimers_large',
        'edelivery-email',
        'dojo-paybills',
        'message-center-app-component',
        'ada-page-content',
        'thirdlevel-ada-nav',
        'fourthlevel-navigation',
        'dojo-da-overview',
        'exchange-agreement-nav',
        'change-default-group',
        'equipt-prelogin',
        'earnedincome-export'
    ];

    static AdaPageContentLinks: any = {
        'dojo-order-entry-container': [
            {
                linkId: 'section-0',
                linkName: 'dojo-order-entry-container-select-account'
            },
            {
                linkId: 'section-1',
                linkName: 'dojo-order-entry-container-select-asset'
            },
            {
                linkId: 'section-4',
                linkName: 'dojo-order-entry-container-define-instruction'
            }
        ]
    };

    static MultiPageContentLinksList: string[] = [
        'dojo-order-entry-container'
    ];

    static isGroupFunctionality: string[] = [
        '529planallocation',
        'historic-activity',
        'historic-rgl',
        'historic-statements',
        'historic-confirms',
        'historic-taxstatements',
        'payrollelection',
        'csfbaibalance',
        'csfbaiholdings',
        'performance',
        'accountperformance',
        'accounts-groups',
        'neworderstatus'
    ];
    static propertyMap = new Map([
        [ '5QH', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '56M', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '5QH', new Map([[ 'netx_investor_mobile_solutions', 'netxinvestor_mobile_solution']])],
        [ '41K', new Map([[ 'about_us_login', 'international_brokerage'], [ 'links', 'links_watani']])],
        [ 'H1X', new Map([[ 'contact_us_login', 'need_assistance']])],
        [ 'C01', new Map([[ 'contact_us_login', 'need_assistance']])],
        [ 'XGW', new Map([[ 'custom_contactus', 'customer_contact_us'], [ 'digital-advice-login-section', 'empower-digital-advice-login-section']])],
        [ 'NV6', new Map([[ 'path_to_investing', 'external_links']])],
        [ '44A', new Map([[ 'site_specific_resources', 'external_links'], [ 'netx_investor_mobile_solutions', 'netxinvestor_mobile_solution']])],
        [ '028', new Map([[ 'netx_investor_mobile_solutions', 'mobile_solution']])],
        [ 'PEC', new Map([[ 'site_specific_resources', 'external_links']])]
    ]);
}
